import * as actionType from "../constants/actionTypes";
import { toast } from "react-toastify";

const initialState = {
  schemas: [],
  loading: false,
  error: null,
  message: "",
};

const schemaExplorerReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.FETCH_SCHEMA:
      return {
        ...state,
        schemas: action.payload?.schemas || [],
        loading: false,
        error: null,
        message: "Fetched successfully",
      };

    case actionType.DELETE_CONNECTION:
      return {
        ...state,
        schemas: state.schemas.filter(
          (schemaName) =>
            schemaName.trim().toLowerCase() !==
            action.payload.name.trim().toLowerCase()
        ),
        loading: false,
        error: null,
        message: action.payload?.content || "Connection deleted successfully",
      };

    default:
      return state;
  }
};

export default schemaExplorerReducer;
